import { ChevronDown } from "lucide-react";

export function CollapsibleSection({ title, subtitle, icon, open, onToggle, testId, children }) {
  return (
    <div className="bg-card border border-border rounded-lg overflow-hidden" data-testid={testId}>
      <button
        type="button"
        onClick={onToggle}
        className="w-full flex items-center justify-between p-4 hover:bg-muted/30 transition-colors text-left"
        data-testid={`${testId}-toggle`}
      >
        <div className="flex items-center gap-2">
          {icon}
          <h4 className="text-sm font-semibold flex items-center gap-2">{title}</h4>
          {subtitle && <span className="text-[10px] text-muted-foreground ml-2">{subtitle}</span>}
        </div>
        <ChevronDown className={`w-4 h-4 text-muted-foreground transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && <div className="px-4 pb-4 pt-0">{children}</div>}
    </div>
  );
}
